import { pendingWrite } from './ReliableWrite';
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import axios from "axios";
import { clearUserInfo, onLoggedin } from "../actions";
import { store } from '../index';
import { getHistory } from '../services/historyService';
import { displayValidationErrors } from './ValidationErrors';
import { reportNetworkFailure, markServerReachable } from './NetworkFeedback';
import { notifyDashboardChange } from './DashboardRefresh';
export const getBranches = async () => {
    return await apiCall('business/branches/get-branches', 'get', null);
}
export const getRoles = async () => {
    return await apiCall('business/settings/role/get-roles', 'get', null);
}
export const getEmployes = async () => {
    return await apiCall('business/user/get-employes', 'get', null);
}
export const getCustomers = async () => {
    return await apiCall('business/customer/get-customer-by-service', 'get', null);
}
export const getSuppliers = async () => {
    return await apiCall('business/cari/get-cari', 'get', null);
}
export const getTypes = async () => {
    return await apiCall('business/operation/type/get-types', 'get', null);
}
export const getStatus = async () => {
    return await apiCall('business/operation/status/get-status', 'get', null);
}
export const getTotalDatas = async (options = {}) => {
    try {
        return await apiCall('business/dashboard/get-total-data', 'get', null, options);

    } catch (e) {
        throw e;
    }
}
export const topTypes = async () => {
    return await apiCall('business/dashboard/get-top-types', 'get', null);
}
export const topBranches = async () => {
    return await apiCall('business/dashboard/get-top-branches', 'get', null);
}
export const sparks = async () => {
    return await apiCall('business/dashboard/get-datas', 'get', null);
}
export const setupDatas = async () => {
    return await apiCall('business/dashboard/get-setup-info', 'get', null);
}
export const getExpenseIncomeCategories = async () => {
    return await apiCall('business/income-expense-categories/local/all', 'get', null);
}
export const getExpenseCategories = async () => {
    return await apiCall('business/income-expense-categories/local/Gider', 'get', null);
}
export const getIncomeCategories = async () => {
    return await apiCall('business/income-expense-categories/local/Gelir', 'get', null);
}
export const formattedPrice = (price) => {
    let mainPrice = price || 0;
    return new Intl.NumberFormat("tr-TR", {
        style: "currency",
        currency: "TRY",
    }).format(mainPrice)
}
export const apiCall = async (url, type, data, options = {}) => {
    var token = localStorage.getItem('token');
    const form = options.form || (document.activeElement && document.activeElement.closest('form'));
    const requestOptions = { timeout: options.timeout ?? (type === 'get' ? 30000 : 0), signal: options.signal };
    const guarded = type === 'post' && /business\/(operation\/(add|add-with-ai|process-data|update-operation-info-update)|(parasut|ksoft)\/withholding\/(add|remove)|customer\/add|receivable\/(collection\/(add|update)|supplier\/(add|update|add-payment|update-collection)))(\/|$)/.test(url);
    let pending = null;
    try {
        pending = guarded ? await pendingWrite(url, data, (()=>{try{const u=JSON.parse(localStorage.getItem('user')||'{}');return u.id ? [u.service_id,u.id] : token;}catch(_){return token;}})(), async key => {
            try {return (await axios.post(process.env.REACT_APP_API_URL+'assistant/commands/settle',{request_key:key,kind:url.replace(/^business\//,'')},{headers:{Authorization:`Bearer ${token}`},timeout:15000})).data;} catch (_) {return null;}
        }) : null;
        if (type === 'post') {
            // For FormData, axios automatically sets Content-Type to multipart/form-data
            // For other data types, set Content-Type to application/json
            const headers = {
                'Authorization': `Bearer ${token}`,
                ...(pending ? { 'Idempotency-Key': pending.key } : {}),
                ...(options.headers || {}),
            };

            // Only set Content-Type if data is not FormData
            if (!(data instanceof FormData)) {
                headers['Content-Type'] = 'application/json';
            }

            const response = await axios.post(process.env.REACT_APP_API_URL + url, data, {
                ...requestOptions,
                headers: headers
            });
            if (pending) pending.finish();
            markServerReachable();
            notifyDashboardChange(url, type, response.data);
            return response.data;
        } else if (type === 'get') {
            const response = await axios.get(process.env.REACT_APP_API_URL + url, {
                ...requestOptions,
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }

            });

            if (pending) pending.finish();
            markServerReachable();
            notifyDashboardChange(url, type, response.data);
            return response.data;
        }
        else if (type === 'delete') {
            const response = await axios.delete(process.env.REACT_APP_API_URL + url, {
                ...requestOptions,
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }

            });

            if (pending) pending.finish();
            markServerReachable();
            notifyDashboardChange(url, type, response.data);
            return response.data;
        }
        else if (type === 'put') {
            const response = await axios.put(process.env.REACT_APP_API_URL + url, data, {
                ...requestOptions,
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }

            });

            if (pending) pending.finish();
            markServerReachable();
            notifyDashboardChange(url, type, response.data);
            return response.data;
        }


    } catch (error) {
        if (pending && error.response && (error.response.status === 422 || ['version_required','stale_record','request_key_required','request_closed'].includes(error.response.data?.code))) pending.finish();
        if (error.code === 'ERR_CANCELED' || (axios.isCancel && axios.isCancel(error))) throw error;
        if (options.background && error.response && error.response.status !== 401) {
            if (error.response.status >= 500) {
                reportNetworkFailure('Arka plan verileri güncellenemedi. Bağlantı yeniden denenecek.', { background: true });
            }
            throw error;
        }

        if (error.response) {
            if (error.response.status === 422) {
                mainHelper.handleErrors(error.response.data?.errors, error.response.status, error.response.data?.message, form);
                throw error;
            }
            else if (error.response.status === 401) {
                if ((token && token !== localStorage.getItem('token')) || localStorage.getItem('isLoggedIn') === 'false') throw error;
                const history = getHistory();          // ✅ global history çek
                localStorage.removeItem('user');
                localStorage.removeItem('token');
                localStorage.setItem('isLoggedIn', 'false');
                store.dispatch(clearUserInfo());
                store.dispatch(onLoggedin(false));
                history.push('/login')
                mainHelper.toastMessage('error', 'Oturum süreniz doldu, lütfen tekrar giriş yapın!');
                throw error;
            }
            else if (error.response.status === 429) {
                mainHelper.toastMessage('error', 'Çok fazla istek gönderildi lütfen daha sonra tekrar deneyiniz!');
                throw error;
            } else if (error.response.status === 500) {
                mainHelper.toastMessage('error', 'Sunucu Hatası!');
                throw error;
            } else if (error.response.status === 501) {
                mainHelper.toastMessage(error.response.data.status, error.response.data.message);
                throw error;
            }
            else if (error.response.status === 402) {
                const msg = error.response.data?.message
                    || 'Üyelik bulunamadı. Lütfen üyeliğinizi kontrol edin.';
                mainHelper.toastMessage('error', msg);
                throw error;
            } else if (error.response.status === 403) {
                mainHelper.toastMessage('error', error.response.data.message);
                throw error;
            } else if (error.response.status === 404) {
                mainHelper.toastMessage('error', error.response.data.message);
                throw error;
            } else {
                mainHelper.toastMessage('error', error.response.data?.message || 'Bir sorun oluştu lütfen daha sonra tekrar deneyiniz.!');
                throw error;
            }
        } else if (error.request) {
            reportNetworkFailure(error.code === 'ECONNABORTED' || error.code === 'ETIMEDOUT'
                ? 'İstek zaman aşımına uğradı. Lütfen bağlantınızı kontrol edin.'
                : 'Sunucudan cevap alınamadı. Lütfen bağlantınızı kontrol edin.',
                { background: options.background, mutating: type !== 'get' });
            throw error;
        } else {
            mainHelper.toastMessage('error', 'Bir sorun oluştu lütfen daha sonra tekrar deneyiniz.')
            throw error;
        }

    }

}
class mainHelper {

    static toastMessage(type, msg) {
        if (type === 'error') {

            return toast.error(msg);

        } else if (type === 'success') {
            return toast.success(msg);
        }
        else if (type === 'warning') {
            return toast.warning(msg);
        }
    }
    static handleErrors(errors, status, message, form) {
        if (status === 500) {
            this.toastMessage('error', 'Kayıt Oluşturulurken Hata Oluştu!');
            return;
        }
        displayValidationErrors(errors, message, text => this.toastMessage('error', text), form);
    }
    static dateFormat(dateString) {
        const dateObject = new Date(dateString);
        return dateObject.toLocaleString('tr-TR', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
        });
    }

    static dateOnlyFormat(dateString) {
        if (!dateString) return '';
        const dateObject = new Date(dateString);
        return dateObject.toLocaleDateString('tr-TR', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        });
    }


}
export default mainHelper;
